import * as React from "react";
import type { SVGProps } from "react";
export const SvgUggLogoU = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 20 27" {...props}>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M15.226 2.696v18.097c-1.806 1.02-3.7 1.536-5.632 1.536-1.932 0-3.826-.516-5.632-1.536V2.696L0 4.448v18.519l.883.59c2.674 1.788 5.686 2.733 8.711 2.733 3.025 0 6.037-.945 8.712-2.733l.882-.59V4.448l-3.962-1.752Z"
      clipRule="evenodd"
    />
    <path
      fill="#3273FA"
      fillRule="evenodd"
      d="M9.493 0 7.512.876v12.966a7.164 7.164 0 0 0 1.98.284c.664 0 1.326-.095 1.982-.284V.876L9.493 0Z"
      clipRule="evenodd"
    />
  </svg>
);
